const SET_MAPS = 'SET_MAPS'
import { cloneDeep }                               from 'lodash';
import request                                     from 'superagent';
import { assemble }                                from '../shared/product.js';
import { constructActiveFilter }                   from './active_filter';
import { setFeatured }                             from './featured';
import { setGenres }                               from './genres';
import { setCategories }                           from './categories';
import { setPromos }                               from './promos';
import { updateActiveProduct }                     from './active_product';
import { closeModal }                              from './active_modal';
import { clearPreorderMessage }                    from './preorder_message';
import { initializeSort }                          from './sort';
import { clearEbookOrderSuccess }                  from './ebook_order_success';

const initialState = new Map();

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_MAPS:
			return action.payload;
		default:
			return state;
	}
}

export function setMaps( maps ){
	return{
		type: SET_MAPS,
		payload: maps
	}
}


export function buildMaps(iterables, oldMaps) {
  let maps        = assemble(iterables, oldMaps);
  let aCategories = [...maps.get('categoryMap').values()];
  let aGenres     = [...maps.get('genreMap').values()];
  let aPromos     = [...maps.get('promoMap').values()];
  let aFeatured   = [...maps.get('featureMap').values()];
  let aProducts   = [...maps.get('productMap').values()];

  return {
    maps       : maps,
    categories : aCategories,
    genres     : aGenres,
    promos     : aPromos,
    featured   : aFeatured,
    products   : aProducts
  }
}

export function initalMoreBooks(){
  let lookupHash = {
    'category' : 'categories',
    'genre'    : 'genres',
    'promo'    : 'promos',
    'product'  : 'products'
  };
  return (dispatch, getState) => {
    let { activeFilterResult, activeFilter, maps, activeProduct, urlParams } = getState();
    if ( ( activeFilter === 'product' && !activeProduct.id )
      || ( activeFilter === 'author' && !activeFilterResult.id )
      || (activeFilterResult && activeFilterResult.products && !activeFilterResult.products.every( p => typeof p === 'object') )){
      let id = (parseInt(urlParams[1], 10) || ( lookupHash[activeFilter] ? getState()[lookupHash[activeFilter]][0].id : getState().store.giftShop[0] ));
      request
        .get('/svc/product/' + activeFilter + '/' + id)
        .set({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
        .end((err, res) => {
          if (err || res.statusCode !== 200 ) console.warn(err);
          let oRevisedMaps = buildMaps(res.body, maps);
          dispatch([
            setMaps( oRevisedMaps.maps ),
            constructActiveFilter(),
            setCategories( oRevisedMaps.categories ),
            setGenres( oRevisedMaps.genres ),
            setPromos( oRevisedMaps.promos ),
            setFeatured( oRevisedMaps.featured ),
            updateActiveProduct(),
            initializeSort()
          ]);
        });
    }

  }
}

/// TODO edit for gift shop landing page, bring up the editor's picks
export function navigateMoreBooks(){
  return (dispatch, getState) => {
    let { activeFilterResult, activeFilter, maps, activeProduct, urlParams } = getState();
    if ( (activeFilter === "product" && !activeProduct.id) ||
      (activeFilterResult && activeFilterResult.products && !activeFilterResult.products.every(p => typeof p === 'object'))){
      let id = activeFilterResult && activeFilterResult.id ?
        activeFilterResult.id : parseInt(urlParams[1], 10);
      request
        .get('/svc/product/' +activeFilter + '/' + id)
        .set({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
        .end((err, res) => {
          if (err || res.statusCode !== 200 ) console.warn(err);
          let oRevisedMaps = buildMaps(res.body, maps);
          return dispatch([
            setMaps( oRevisedMaps.maps ),
            constructActiveFilter(),
            setCategories( oRevisedMaps.categories ),
            setGenres( oRevisedMaps.genres ),
            setPromos( oRevisedMaps.promos ),
            setFeatured( oRevisedMaps.featured ),
            updateActiveProduct(),
            closeModal(),
            clearPreorderMessage(),
            clearEbookOrderSuccess(),
            initializeSort()
          ]);
        });
    } else
     return dispatch([
        clearPreorderMessage(),
        clearEbookOrderSuccess(),
        initializeSort()
      ]);
  }
}



// WEBPACK FOOTER //
// ./src/modules/maps.js